const UserIcon = () => {
  return (
    <svg
      id="Group_9456"
      data-name="Group 9456"
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28.367"
      viewBox="0 0 28 28.367"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5542"
            data-name="Rectangle 5542"
            width="28"
            height="28.367"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9455" data-name="Group 9455" clipPath="url(#clip-path)">
        <path
          id="Path_12180"
          data-name="Path 12180"
          d="M117.153,0a8.264,8.264,0,0,0-8.162,8.362,8.465,8.465,0,0,0,1.432,4.732,8.054,8.054,0,0,0,13.46,0,8.466,8.466,0,0,0,1.432-4.732A8.264,8.264,0,0,0,117.153,0"
          transform="translate(-103.308)"
          fill="#707070"
        />
        <path
          id="Path_12181"
          data-name="Path 12181"
          d="M20.389,281.79a7.817,7.817,0,0,1-6.544,3.048A7.817,7.817,0,0,1,7.3,281.79C2.982,284.3.918,289.208,0,295.106H28c-.918-5.9-3.292-10.809-7.611-13.316"
          transform="translate(0 -266.739)"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default UserIcon
